// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/swiper.min.css
// module id = Qwh1
// module chunks = 12